import { graphql } from 'react-relay';

const createClearstreamCashTransferPreAdviseFile = graphql`
  mutation CreateClearstreamCashTransferPreAdviseFileMutation(
    $forDate: Date
    $pendingTransactionIds: [ID]
    $settledTransactionIds: [ID]
  ) {
    createClearstreamCashTransferPreAdviseFile (
      forDate: $forDate
      pendingTransactionIds: $pendingTransactionIds
      settledTransactionIds: $settledTransactionIds
    ){
      preAdviseFile {
        id
        createdAt
        csvUrl
        csv
      }
    }
  }
`;
export default createClearstreamCashTransferPreAdviseFile;
